import "./SinglePostTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SinglePostTemplate from "./sections/SinglePostTemplate"
import ClinicAgatasInformation from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <Header />
      <SinglePostTemplate />
      <ClinicAgatasInformation />
    </div>
  )
}
